import React, { useEffect, useMemo } from 'react';

import { useLazyReadFeedbacksQuery } from 'features/admin/features/feedback/service/adminFeedbackApi';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import {
    FeedbacksFiltersProps,
    FeedbacksProps,
} from '../service/feedback.interface';
import { getColumns } from '../utils/getColumns';
import UniversalTable from '../../../components/UniversalTable';

export const FeedbackContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        FeedbacksFiltersProps,
        FeedbacksProps
    >(useLazyReadFeedbacksQuery, null);

    const tableProps = useMemo<
        CommonTableProps<FeedbacksProps, FeedbacksFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumns,
            entityName: 'Отзывов',
            rowKey: item => item.id,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);

    return <UniversalTable {...tableProps} />;
};
